import { render, staticRenderFns } from "./AccountsPlan.vue?vue&type=template&id=8470f052&scoped=true"
import script from "./AccountsPlan.vue?vue&type=script&lang=js"
export * from "./AccountsPlan.vue?vue&type=script&lang=js"
import style0 from "./AccountsPlan.vue?vue&type=style&index=0&id=8470f052&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8470f052",
  null
  
)

export default component.exports